import React from 'react';
import { RHFTextField } from '@talentmesh/forms';
import Constants from '../Constants';
import ApplicantInformationType from '../../../../../../Models/ApplicantInformationType';
import useTMTranslation from '../../../../../../Hooks/useTMTranslation';

function WhereDoYouSeeYourself(): React.JSX.Element {
    const { tCommon: t } = useTMTranslation();

    return (
        <RHFTextField
            multiline
            fullWidth
            label={`${t('WhereDoYouSeeYourselfInTheNextFewYears')}*`}
            name={ApplicantInformationType.WhereDoYouSeeYourself}
            rows={Constants.numberOfRows}
            maxChar={Constants.textFieldLargeCapacity}
        />
    );
}

export default WhereDoYouSeeYourself;
